/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<8d13466ccb0e63bd154f474864e7c4a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOfTopicsElementFragment$data = {
  readonly topics: ReadonlyArray<{
    readonly hidden: boolean | null | undefined;
    readonly items: ReadonlyArray<{
      readonly __typename: "HelpLayoutTopicItem";
    }> | null | undefined;
    readonly topicId: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"topicCardFragment">;
  }> | null | undefined;
  readonly " $fragmentType": "listOfTopicsElementFragment";
};
export type listOfTopicsElementFragment$key = {
  readonly " $data"?: listOfTopicsElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOfTopicsElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "listOfTopicsElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "topicId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpLayoutTopicItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicCardFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpLayoutTopicsListElement",
  "abstractKey": null
};

(node as any).hash = "460344e600bed13c0fe8c76ecd7dd833";

export default node;
